module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel panel-primary"
  }, [_c('div', {
    staticClass: "panel-heading padding-0"
  }, [_c('h3', {
    staticClass: "text-center panel-title"
  }, [_c('a', {
    staticClass: "collapsable-link-panel collapsable-icon-container",
    attrs: {
      "href": "#content-message-sets",
      "data-toggle": "collapse"
    }
  }, [_vm._v("\n          Message Sets\n          "), _c('div', {
    staticClass: "style-new-icon"
  }, [_c('i', {
    staticClass: "fa fa-gift",
    staticStyle: {
      "font-size": "22px"
    },
    attrs: {
      "aria-hidden": "true",
      "title": "New Features!"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.showInfoPopUp.apply(null, arguments)
      }
    }
  })])])])]), _vm._v(" "), (_vm.showNewFeaturePrompt) ? _c('div', {
    staticClass: "modal-backdrop"
  }, [_c('div', {
    staticClass: "modal new-feature",
    staticStyle: {
      "height": "415px",
      "width": "518px"
    },
    attrs: {
      "role": "dialog",
      "aria-labelledby": "modalTitle",
      "aria-describedby": "modalDescription"
    }
  }, [_c('header', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "header-style"
  }, [_c('h3', [_vm._v("New Features !")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "font-size": "22px",
      "color": "red"
    },
    attrs: {
      "title": "Close"
    },
    on: {
      "click": _vm.closeNewFeatureModal
    }
  })])]), _vm._v(" "), _c('section', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "style-section"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_vm._v("We can now add buttons for message instead of asking the user to type the numbers.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "style-select-options"
  }, [_vm._v("Please select one of the following options :- ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.showTextInfoForButton))]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', [_vm._v("We can support lists instead of buttons whenever the user has more than 3 options to be selected.")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "style-select-options"
  }, [_vm._v("Please select one of the following options :- ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.showTextInfoForList))]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', [_c('b', [_vm._v("Token to add Account ID ")]), _vm._v("(Token would be replaced with user's account id):- "), _c('span', [_vm._v(_vm._s(_vm.showTextInfoForAccountId))])]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Token to add Pharmacy Name ")]), _vm._v("(currently we are only using in Delay Tactics):- "), _c('span', [_vm._v(_vm._s(_vm.showTextInForPharmacyName))])]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Token to add User Name ")]), _vm._v("(Currently, supported only for Ninety JoR):- "), _c('span', [_vm._v(_vm._s(_vm.showTextInForUserName))])]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Token to display User Location ")]), _vm._v("(The token would get replaced with user location):- "), _c('span', [_vm._v(_vm._s(_vm.showTextInfoForUserLocation))])]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Token to show map link based on referral ")]), _vm._v("(currently used only in message sets):- "), _c('span', [_vm._v(_vm._s(_vm.showTextInfoForMapOfReferral))])]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Token to show link of MSK resource in the DDE ")]), _vm._v("(currently we are not showing during the msk resource display. So, we have to show it in the DDE via this token):- "), _c('span', [_vm._v(_vm._s(_vm.showTextInfoForMSKLink))])]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Use this token to show a gift card or coupon to the user")]), _vm._v(". The number in the token represents the gift card's price. Example:- "), _c('span', [_vm._v(_vm._s(_vm.showTextInfoForGiftCard))]), _vm._v(" would display a gift card worth amount of 150.")]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Use this token to display the Nivi digital voucher to the user.")]), _vm._v(".  The voucher format is NIVI-YYMMDD-UNIQUEID. Example:- "), _c('span', [_vm._v(_vm._s(_vm.showTextInfoForDigitalVoucher))]), _vm._v(" will generate and send a digital voucher code to the user, such as NIVI-250715-X92.")]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Use this token to send airtime via Africa's Talking to the user")]), _vm._v(". The number in the token represents the airtime in KES. Example:- "), _c('span', [_vm._v(_vm._s(_vm.showTextInfoForAirtime))]), _vm._v(" would send airtime worth 10 KES.")]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Use this token to send appointment booking details to Ninety user")]), _vm._v(". There are 4 tokens for date, time, booking id, and clinic. Example:- "), _c('span', [_vm._v(_vm._s(_vm.showTextInfoForNinetyForAppointment))]), _vm._v(" This would send the actual data from appointment_booking table")]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Token to add Provider code ")]), _vm._v(":- "), _c('span', [_vm._v(_vm._s(_vm.showTextInForProviderCode))])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "collapse in",
    attrs: {
      "id": "content-message-sets"
    }
  }, [_c('div', {
    staticClass: "panel-body message-table-container"
  }, [_c('div', {
    staticClass: "message-set-header"
  }, [_c('div', {
    staticClass: "add-message-container"
  }, [_c('button', {
    staticClass: "btn btn-add-message",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addMessage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Add Message\n            ")]), _vm._v(" "), (_vm.formattedMessageSet.length) ? _c('div', {
    staticClass: "view-option",
    attrs: {
      "role": "radiogroup",
      "aria-label": "Show messages"
    }
  }, _vm._l((_vm.viewOptions), function(option) {
    return _c('label', {
      key: option.value,
      staticClass: "view-option-radio",
      class: {
        'view-option-radio--active': _vm.selectedViewOption === option.value
      },
      on: {
        "change": _vm.toggledRadio
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedViewOption),
        expression: "selectedViewOption"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": option.value,
        "checked": _vm._q(_vm.selectedViewOption, option.value)
      },
      on: {
        "change": function($event) {
          _vm.selectedViewOption = option.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa",
      class: option.value === 0 ? 'fa-expand' : 'fa-compress',
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(option.label) + "\n              ")])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.formattedMessageSet.length) ? _c('label', {
    staticClass: "hide-empty-translation",
    class: {
      'hide-empty-translation--on': _vm.hideEmptyTranslations
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hideEmptyTranslations),
      expression: "hideEmptyTranslations"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.hideEmptyTranslations) ? _vm._i(_vm.hideEmptyTranslations, null) > -1 : (_vm.hideEmptyTranslations)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.hideEmptyTranslations,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.hideEmptyTranslations = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.hideEmptyTranslations = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.hideEmptyTranslations = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(5), _vm._v("\n            Hide languages with no translation\n          ")]) : _vm._e()]), _vm._v(" "), (!_vm.formattedMessageSet.length) ? _c('div', {
    staticClass: "message-empty"
  }, [_c('i', {
    staticClass: "fa fa-comment-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("No message present for this stage. Click on \"Add Message\" to add new message")])]) : _vm._e(), _vm._v(" "), (_vm.formattedMessageSet.length) ? _c('table', {
    staticClass: "message-list",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [(_vm.formattedMessageSet && Object.keys(_vm.formattedMessageSet).length) ? _c('draggable', {
    attrs: {
      "tag": "tbody"
    },
    model: {
      value: (_vm.formattedMessageSet),
      callback: function($$v) {
        _vm.formattedMessageSet = $$v
      },
      expression: "formattedMessageSet"
    }
  }, _vm._l((_vm.formattedMessageSet), function(message, index) {
    return _c('tr', {
      key: index
    }, [_c('message', {
      attrs: {
        "message": message,
        "index": index,
        "stageName": _vm.stageName,
        "countryLangMapping": _vm.countryAndLanguages,
        "hideEmptyTranslations": _vm.hideEmptyTranslations,
        "getViewOption": _vm.getViewOption,
        "selectedViewOption": _vm.selectedViewOption,
        "emitUpdatedMessage": _vm.emitUpdatedMessage,
        "validateMessage": _vm.validateMessage
      },
      on: {
        "deleteMessage": _vm.deleteMessage,
        "updateMessage": _vm.updateMessage,
        "updateMessageValidation": _vm.updateMessageValidation
      }
    })], 1)
  }), 0) : _vm._e()], 1) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "style-button-section"
  }, [_c('b', [_vm._v("Button")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "style-template-text"
  }, [_c('b', [_vm._v("Template to use button:- ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "style-list-section"
  }, [_c('b', [_vm._v("List")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "style-template-text"
  }, [_c('b', [_vm._v("Template to use list:- ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "style-list-section"
  }, [_c('b', [_vm._v("Token")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "hide-empty-translation__track"
  }, [_c('span', {
    staticClass: "hide-empty-translation__thumb"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4321ad7d","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/messageSet.vue
// module id = RwHU
// module chunks = 1